<template>
    <a-modal title="添加常用批语"
             :width="960"
             :visible="visible"
             :maskClosable="false"
             @ok="add"
             @cancel="$emit('cancel')"
             :confirmLoading="modalLoading">
        <a-form :form="form">
            <table class="fx-form">
                <tr>
                    <th class="not-null">顺序号</th>
                    <td>
                        <a-form-item>
                            <a-input-number :min="0" v-decorator="['seqNo',{ rules: [{ required: true, message: '请输入顺序号' }]}]"
                            />
                        </a-form-item>
                    </td>
                </tr>
                <tr>
                    <th class="not-null">批语使用人</th>
                    <td>
                        <a-form-item>
                            <a-select v-if="hasManagerPerm" style="width: 170px" v-model="type">
                                <a-select-option value="1">本人使用</a-select-option>
                                <a-select-option value="2">他人使用</a-select-option>
                            </a-select>
                            <a-select v-else style="width: 170px" v-model="type">
                                <a-select-option value="1">本人使用</a-select-option>
                            </a-select>
                        </a-form-item>
                    </td>
                </tr>
                <tr v-if="type === '2'">
                    <th class="not-null">批语使用人</th>
                    <td>
                        <a-form-item>
                            <user-selector v-decorator="['userId', {initialValue:initData.userId, rules: [{ required: true, message: '请选择批语使用人' }]}]" />
                        </a-form-item>
                    </td>
                </tr>
                <tr>
                    <th class="not-null">批语内容</th>
                    <td>
                        <a-form-item>
                            <a-textarea v-decorator="['content',{ rules: [{ required: true, message: '请输入批语内容' }]}]"/>
                        </a-form-item>
                    </td>
                </tr>
                <tr>
                    <th>备注</th>
                    <td>
                        <a-form-item>
                            <a-textarea v-decorator="['memo',{ rules: [{ required: false, message: '请输入备注' }]}]"/>
                        </a-form-item>
                    </td>
                </tr>
            </table>
        </a-form>
    </a-modal>
</template>

<script>
import qs from 'qs'
import UserSelector from '@/components/selector/UserSelector'
export default {
  name: 'OpinionPersonalAdd',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  components: {
    UserSelector
  },
  created () {
    const user = this.$ls.get('user')
    this.initData.userId = user.id
  },
  computed: {
    hasManagerPerm: function () {
      const user = this.$ls.get('user')
      return user.permissions['workflow.opinion.personal']
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      modalLoading: false,
      type: '1',
      hasRole: false,
      initData: {
      }
    }
  },
  methods: {
    preView () {
    },
    add () {
      this.form.validateFields((err, values) => {
        if (err) {
          return
        }
        const that = this
        let data = that.form.getFieldsValue()
        if (that.type === '1') {
          data.userId = that.initData.userId
        }
        data.createUserId = that.initData.userId
        data.state = 'E'
        this.$http.post('/api/1/workflow/opinion/personal/add_opinion_personal.json', qs.stringify(data)).then(function (response) {
          if (response.code !== 200) {
            return
          }
          that.$message.success('操作成功')
          that.$emit('success')
          that.form.resetFields()
        }).catch(function () {
        })
      })
    }
  }
}
</script>

<style scoped>
    .fx-form th {
        width: 120px;
    }
</style>
